var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-base"},[_vm._t("default"),_vm._v(" "),_c('img',{staticClass:"qfact-logo-bottom",attrs:{"src":"/statics/img/Qfact-logo.svg","alt":""}}),_vm._v(" "),_c('notifications')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }